<!-- src/App.vue -->

<template>
  <div>
    <ControlButtons @update-shape="changeShape" @update-period="changePeriod" />
    <ParticleScene :shape="currentShape" :artworks="currentArtworks" />
  </div>
</template>

<script>
import ControlButtons from "./components/ControlButtons.vue";
import ParticleScene from "./components/ParticleScene.vue";

import protoRenaissance from "./data/proto_renaissance.json";
import earlyRenaissance from "./data/early_renaissance.json";
import highRenaissance from "./data/high_renaissance.json";
import lateRenaissance from "./data/late_renaissance.json";

export default {
  name: "App",
  components: { ControlButtons, ParticleScene },
  data() {
    return {
      currentShape: "random",
      currentPeriod: "Proto-Renaissance",
      periods: {
        "Proto-Renaissance": protoRenaissance.artists,
        "Early Renaissance": earlyRenaissance.artists,
        "High Renaissance": highRenaissance.artists,
        "Late Renaissance": lateRenaissance.artists,
      },
    };
  },
  computed: {
    currentArtworks() {
      const artworks =
        this.currentPeriod === "All"
          ? Object.entries(this.periods).flatMap(([periodName, artists]) =>
              artists.flatMap((artist) =>
                artist.works.map((work) => ({
                  ...work,
                  artist: artist.name,
                  period: periodName,
                }))
              )
            )
          : this.periods[this.currentPeriod].flatMap((artist) =>
              artist.works.map((work) => ({
                ...work,
                artist: artist.name,
                period: this.currentPeriod,
              }))
            );
      // Сортируем произведения по году
      return artworks.sort((a, b) => a.year - b.year);
    },
  },
  methods: {
    changeShape(shape) {
      this.currentShape = shape;
    },
    changePeriod(period) {
      this.currentPeriod = period;
    },
  },
};
</script>

<style>
body {
  margin: 0;
  background: black;
  overflow: hidden;
}
</style>
